import './js/services/services';
import './js/modal';
import './js/addqueue';
import './js/render_cards';
import './js/render_cards_two';
import './js/add_to_watched';
import './js/pagination_main';
import './js/modal_students';
import './js/search_by_name';

